<template>
    <div>
        <el-upload :action="uploadAction" :limit="6" name="image" :multiple="true" :data="uploadData"
            :headers="uploadHeader" :file-list="fileList" list-type="picture-card" :on-remove="handleRemove"
            :on-success="handleUploadFileSuccess" :before-remove="beforeRemove">
            <i class="el-icon-plus"></i>
        </el-upload>
    </div>
</template>

<script>
import { objKeySort } from '@/utils/auth'
import { getStorage } from '@/utils/auth'
export default {
    name: 'FromImages',
    components: {

    },
    props: {
        value: {
            type: Array,
            default: []
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        fileList(value) {
            console.log(value)
            this.$emit('change', value)
        },
        value(value) {
            this.fileList = value
        }
    },
    data() {
        return {
            uploadAction: process.env.VUE_APP_BASE_API + 'common/uploadImage',
            uploadHeader: { Authorization: getStorage('token') },
            uploadData: {
                sign: objKeySort([])[2]
            },
            fileList: this.value,
        }
    },
    methods: {
        handleUploadFileSuccess(res, file) {
            console.log(1111, file)
            console.log(222, res)
            this.fileList.push({
                uid: file.uid,
                url: res.data,
                name: file.name
            })
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
            console.log(file, fileList)
        },
        clearFiles() {
            this.fileList = []
            if (this.$refs.uploadFile) {
                this.$refs['uploadFile'].clearFiles()
            }
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
    }
}
</script>
<style lang="scss" scoped>

</style>